import { render, staticRenderFns } from "./RecentJoinRequestWrapper.vue?vue&type=template&id=f9ddc4cc&scoped=true&"
import script from "./RecentJoinRequestWrapper.vue?vue&type=script&lang=js&"
export * from "./RecentJoinRequestWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RecentJoinRequestWrapper.vue?vue&type=style&index=0&id=f9ddc4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ddc4cc",
  null
  
)

export default component.exports